import {RefObject, useCallback, useEffect} from 'react';

export const useBackgroundClick = (
  ref: RefObject<any>,
  onClick?: (e: any) => void,
  excludes?: Array<RefObject<any>>
) => {
  const handleClickOutside = useCallback(
    (e: MouseEvent) => {
      if (ref?.current && !ref.current.contains(e.target)) {
        if (excludes?.length) {
          let flag = false;

          // tslint:disable-next-line: prefer-for-of
          for (let i = 0; i < excludes.length; i++) {
            const elem = excludes[i];
            if (elem.current?.contains?.(e.target)) {
              flag = true;
              break;
            }
          }

          if (!flag) {
            onClick?.(e);
          }
        } else {
          onClick?.(e);
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ref, onClick]
  );

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, excludes, onClick]);
};
